import { BehaviorSubject } from 'rxjs';
import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { SitemapNode } from '../sitemap-node';
import { SesionService } from '../services/sesion.service';
import { environment } from '../../environments/environment';
import { BaseComponent } from '../base-component';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'common-foot',
  templateUrl: './foot.component.html',
  styleUrls: ['./foot.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FootComponent extends BaseComponent implements OnInit {
  constructor(private cdr: ChangeDetectorRef,
    private langService: LanguageService) {
    super()
    this.rutaIngles = this.sesion.rutaIdioma('en');
    this.rutaCastellano = this.sesion.rutaIdioma('es');
    this.rutaPortugues = this.sesion.rutaIdioma('pt');
  }

  directoryImages: string;
  nodoPie: SitemapNode;

  rutaIngles: BehaviorSubject<Array<any>>;
  rutaCastellano: BehaviorSubject<Array<any>>;
  rutaPortugues: BehaviorSubject<Array<any>>;

  get year(): string {
    return new Date().getFullYear().toString();
  }

  ngOnInit() {
    this.addSubscription(this.langService.language$.subscribe(async () => {
      this.nodoPie = await this.langService.instantAsync('Foot.rootNode').toPromise();
      this.cdr.detectChanges();
    }));
  }
}
